import { PayloadAction } from '@reduxjs/toolkit';
import NoticeDetail from '@/components/pages/user/community/notice/notice-detail';
import type {
  ICommonBoardFaqTypes, IPublicBoard, IPublicBoardOne, PublicBoardName,
} from '../../types';
import { createSliceSteamup } from '../common';

type IPublicBoardState = {
  notice: IPublicBoardOne;
  library: IPublicBoardOne;
  qna: IPublicBoardOne;
  faq: IPublicBoardOne;
  noticeDetail: IPublicBoard;
  faqType: ICommonBoardFaqTypes[];
  noticeDetailNextUUID: {};
  noticeDetailPrevUUID: {};
  noticeIsStrong: boolean;
};

const publicBoardSlice = createSliceSteamup(
  'publicBoard',
  {
    notice: { total: 0, loading: true },
    library: { total: 0, loading: true },
    qna: { total: 0, loading: true },
    faq: { total: 0, loading: true },
    noticeDetail: {},
    faqType: {},
    noticeDetailNextUUID: {},
    noticeDetailPrevUUID: {},
    noticeIsStrong: false,
  } as IPublicBoardState,
  {
    setData(state, { payload }: PayloadAction<{ type: PublicBoardName, data: IPublicBoardOne}>) {
      state[payload.type] = payload.data;
    },
    setNoticeDetailData(state, { payload }: PayloadAction<(typeof state.noticeDetail)>) {
      state.noticeDetail = payload;
    },
    setFaqTypeData(state, { payload }: PayloadAction<(typeof state.faqType)>) {
      state.faqType = payload;
    },
    // setNoticeIsStrong(state, { payload }: PayloadAction<(typeof state.notice)>) {
    //   state.noticeIsStrong = payload.data.filter((isStrong) => isStrong);
    // },
  },
);

export default publicBoardSlice;
